import React, { useCallback, useContext, useState } from "react";
import { ActionList, Button, LegacyCard as Card, Collapsible } from "@shopify/polaris";

// config
import { PrivateContext } from "lib/context";
import constant from "lib/constant/constant";
// import quickLinkConfig from "./quickLinksConfig";
// import { config, title } from "../quickSetting/quickSettingConfig";
import quickSettingConfig from "app/reports/admin/widgets/quickSetting/quickSettingConfig";
import { useLocation, useMatch, useNavigate } from "react-router-dom";
import quickLink from "./quickLinksConfig";

const AdminQuickLinks = () => {
  const { cms } = useContext(PrivateContext);
  const navigate = useNavigate();
  const location = useLocation();
  const path = location.pathname;
  const [openActionLink, setActive] = useState(true);
  const [actionLinkExpanded, setExpanded] = useState(false);
  const handleToggle = useCallback(() => setActive((actionLink) => !actionLink), []);
  const quickLinkConfig = quickLink(cms);
  const { config, title } = quickSettingConfig(cms);
  const actionCard = (link) => {
    const onAction = () => navigate(link.link);
    return (
      <ActionList
        sections={[
          {
            items: [
              {
                content: link.label,
                helpText: link.caption,
                icon: link.icon,
                onAction,
              },
            ],
          },
        ]}
      />
    );
  };

  const getQuickLinks = (links = []) => {
    return links.map((link) => actionCard(link));
  };

  const getQuickSettings = (settings = []) => {
    return settings.map((setting) => actionCard(setting));
  };

  return (
    <Card>
      <Card.Header title={constant.ACTION}>
        <Button
          plain
          disclosure={actionLinkExpanded ? "down" : "up"}
          onClick={() => {
            handleToggle();
            setExpanded(!actionLinkExpanded);
          }}
        >
          {actionLinkExpanded ? "Show" : "Hide"}
        </Button>
      </Card.Header>

      <br />

      <Collapsible
        open={openActionLink}
        id="collapsibleQuickLink"
        transition={{ duration: "150ms", timingFunction: "ease" }}
      >
        <Card>
          <Card.Section subdued>{getQuickLinks(quickLinkConfig[path])}</Card.Section>

          {config[path] && (
            <Card.Section subdued title={title[path] || cms("common.actions.title.setting")}>
              {getQuickSettings(config[path])}
            </Card.Section>
          )}
        </Card>
      </Collapsible>
    </Card>
  );
};

export default AdminQuickLinks;
